import { render, staticRenderFns } from "./ArrangeLink.vue?vue&type=template&id=68c8b856"
import script from "./ArrangeLink.vue?vue&type=script&lang=js"
export * from "./ArrangeLink.vue?vue&type=script&lang=js"
import style0 from "./ArrangeLink.vue?vue&type=style&index=0&id=68c8b856&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports